import styles from './InputField.module.css';

const InputField = ({ placeholder, type, onChange, value }) => {
  return (
    <div className={styles.inputField}>
      <label htmlFor={placeholder} className={styles.label}>
        {placeholder}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        id={placeholder}
        className={styles.field}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

InputField.defaultProps = {
  type: 'text',
};

export default InputField;
